// extracted by mini-css-extract-plugin
export default {"textWrapper":"TextNotification_textWrapper--Fl7"};